import React from "react";
import PropTypes from "prop-types";
import IDLink from "../../ui/IDLink";
import Timestamp from "../../ui/Timestamp";
import { useSelector } from "react-redux";
import { selectAdvancedMode } from "../settings/slice";
import RSOOrbitRegime from "./RSOOrbitRegime";
import Pill from "../../ui/Pill";

/**
 * Similar to RSOSummary, but renders a naked set of <dt>/<dd>
 * of an RSO's properties, for use in e.g. a <Facts> header module.
 */
const RSOProps = ({
	id,
	object_name,
	object_id,
	object_type,
	updated_at,
	group,
	alt_name,
}) => {
	const advancedMode = useSelector(selectAdvancedMode);
	return (
		<>
			<dt>Name</dt>
			<dd>
				{object_name || alt_name || "-"}{" "}
				{object_id && <span>({object_id})</span>}{" "}
				{group == "user" && <Pill>custom</Pill>}
			</dd>
			<dt>ID</dt>
			<dd>{id && <IDLink to={`/rsos/${id}`}>{id}</IDLink>}</dd>
			{object_type && (
				<>
					<dt>Type</dt>
					<dd>{object_type.toLocaleLowerCase()} </dd>
				</>
			)}
			{updated_at && (
				<>
					<dt>Updated</dt>
					<dd>
						<Timestamp utc={advancedMode}>{updated_at}</Timestamp>
					</dd>
				</>
			)}
			<dt>Orbital regime</dt>
			<dd>
				<RSOOrbitRegime id={id} />
			</dd>
		</>
	);
};

RSOProps.propTypes = {
	id: PropTypes.string, // The Norad id for the RSO
	object_name: PropTypes.string, // Human-readable name of the object
	object_id: PropTypes.string, //
	object_type: PropTypes.string, // The Norad classification of this object e.g. Debris, Payload, etc
	updated: PropTypes.string, // The last time the Astrosite was updated
	group: PropTypes.string, // typically either spacetrack or user but could be exo or solar (represents the object database used)
	alt_name: PropTypes.string,
};

export default RSOProps;
